module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/network/network.component.html
// module id = ./src/app/Pages/manage/network/network.component.html
// module chunks = main